import React, { IframeHTMLAttributes, useEffect } from 'react';
import useSlideMenuCollapsedChange from '@/hooks/useSlideMenuCollapsedChange';

export default function IFrame(props: IframeHTMLAttributes<unknown> & { iframename?: string }) {
  const { style = {}, src, iframename, ..._props } = props;
  const [collapsedStatus, _, toggleSidemenuCollapsedSatus] = useSlideMenuCollapsedChange('close', 'open');

  useEffect(() => {
    if (!iframename) return;

    function handelToggle(e: any) {
      if (e?.data?.from !== iframename) return;
      if (collapsedStatus === e?.data?.letSlideMenu) return;

      toggleSidemenuCollapsedSatus();
    }
    window.addEventListener('message', handelToggle, false);
    return () => {
      window.removeEventListener('message', handelToggle, false);
    };
  }, [collapsedStatus, toggleSidemenuCollapsedSatus, iframename]);

  return (
    <iframe style={{ width: '100%', height: 'calc(100vh - 48px)', border: 'none', ...style }} src={src} {..._props} />
  );
}
